// @ts-nocheck
import './base.css'
import './style.css'

export default function Acendex() {
    return null
}
